var $ = jQuery;

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

$(document).ready(function(){
    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(4)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(5)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(6)) || 
		 isOnScreen($("#footer")) )   {
    	$(".sticky-atc-button").fadeOut(100);

  	} else {
    	$(".sticky-atc-button").fadeIn(100);
  	}
  
  	$(window).on('scroll',function(){
    	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(4)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(5)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(6)) || 
			isOnScreen($("#footer")) )   {
      		$(".sticky-atc-button").fadeOut(10);
      
    	} else {
     		$(".sticky-atc-button").fadeIn(10);
    	}
  	});	
    /* scroll to target */
    let annoincementBarHeight = $('.announcement-bar').height();
    let deskHeaderHeight = $('.header').height();
    let deskTotalHeight = deskHeaderHeight + annoincementBarHeight;

    let mbHeaderHeight = $('.mobile-header').height();
    let mbTotalHeight = mbHeaderHeight + annoincementBarHeight;
    


    /* scroll to target */
    jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        if ($(window).width > 767) {
            var scroll = -deskTotalHeight;
            console.log('deskTotalHeight if' + deskTotalHeight)
        } else {
            var scroll = -mbTotalHeight;
            console.log('mbTotalHeight else' + mbTotalHeight)
        }
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });


    if ($('.jsClientLogoSlider').length > 0) {
        $('.jsClientLogoSlider').slick({
            speed: 3000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false
        });
    }
    if ($('.jsLovedByCustomers').length > 0) {
        $('.jsLovedByCustomers').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            appendDots: $('.custom-dots'),
            prevArrow: '.custom-prev',
            nextArrow: '.custom-next',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1.4,
                        slidesToScroll: 1,
                        dots: false,
                        infinite: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });
    }   

    if ($('.jsSupportedByVets').length > 0) {
        $('.jsSupportedByVets').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            appendDots: $('.custom-dots-supported-vets'),
            prevArrow: '.custom-prev-supported-vets',
            nextArrow: '.custom-next-supported-vets',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        infinite: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });
    }    
    
    function applyMatchHeight() {
        var windowWidth = $(window).width();

        if (windowWidth <= 991) {
            // Apply matchHeight plugin
            $('.sp-immunity-treats__box-list li').matchHeight({
                byRow: false,
            });
            $('.healthy-food-list li, .regular-food-list li').matchHeight({
                byRow: false,
            }); 
        } else {
            // Remove matchHeight if window width is greater than 991
            $('.sp-immunity-treats__box-list li').matchHeight('remove');
            $('.healthy-food-list li, .regular-food-list li').matchHeight('remove');
        }
    }

    // Initial application on document ready
    applyMatchHeight();

    // Reapply on window resize
    $(window).resize(function() {
        applyMatchHeight();
    });

    if($('.sp-ingredients__box h6').length > 0){
        $('.sp-ingredients__box h6').matchHeight({
            byRow: true,
        });    
    }
    if($('.sp-benefits-nutri-paw__box h6').length > 0){
        $('.sp-benefits-nutri-paw__box h6').matchHeight({
            byRow: true,
        });    
    } 
    if($('.sp-loved-by-customers__review-box > p').length > 0){
        $('.sp-loved-by-customers__review-box > p').matchHeight({
            byRow: true,
        });    
    }       

    // accordian js start here
    $(function () {
        $('.cus-accordian-title').click(function (j) {

            var dropDown = $(this).closest('.cus-accordian-card').find('.cus-accordian-panel');
            $(this).closest('.cus-accordian').find('.cus-accordian-panel').not(dropDown).slideUp();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.cus-accordian-card').removeClass('active');
            } else {
                $(this).closest('.cus-accordian').find('.cus-accordian-title.active').removeClass('active');
                $(this).addClass('active');
                $(this).closest('.cus-accordian').find('.cus-accordian-card.active').removeClass('active');
                $(this).parents('.cus-accordian-card').addClass('active');

            }

            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
        });
    });
    // accordian js end here
    
    // accordian js start here
    $(function () {
        $('.sp-cus-accordian-title').click(function (j) {

            var dropDown = $(this).closest('.sp-cus-accordian-card').find('.sp-cus-accordian-panel');
            $(this).closest('.sp-cus-accordian').find('.sp-cus-accordian-panel').not(dropDown).slideUp();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.sp-cus-accordian-card').removeClass('active');
            } else {
                $(this).closest('.sp-cus-accordian').find('.sp-cus-accordian-title.active').removeClass('active');
                $(this).addClass('active');
                $(this).closest('.sp-cus-accordian').find('.sp-cus-accordian-card.active').removeClass('active');
                $(this).parents('.sp-cus-accordian-card').addClass('active');

            }

            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
        });
    });
    // accordian js end here

    /* product slider start */
    if($('.jsProductBannerMain').length) {
        $('.jsProductBannerMain').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            // lazyLoad: 'progressive',
            asNavFor: '.jsProductBnnerNav',            
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: true,
                    }
                }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
            
        });
    }
                
    if($('.jsProductBnnerNav').length) {
        $('.jsProductBnnerNav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.jsProductBannerMain',
            dots: false,
            arrows: true,
            centerMode: false,
            // lazyLoad: 'progressive',
            focusOnSelect: true,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.96875" width="28" height="28" rx="14" fill="#18D371"/><path d="M16.6004 19.1686L12.4004 14.9686L16.6004 10.7686" stroke="white" stroke-width="1.86667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="28" height="28" rx="14" transform="matrix(-1 0 0 1 28.5 0.96875)" fill="#18D371"/><path d="M12.3996 19.1686L16.5996 14.9686L12.3996 10.7686" stroke="white" stroke-width="1.86667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                    vertical: false,
                    slidesToShow: 5,
                    slidesToScroll: 1
                    }
                }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
        });
    }
    /* product slider END */

    $(document).on('click','.lp-add-to-cart',function(){
        var quantity = 1;
        quantity = parseInt(quantity);
        var id="36559416262817";
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {id:id,quantity:quantity},
            success: function(){
                location.href="/checkout";
            }
        });
    });

});